export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/market_research.78da802.svg";